module.exports = __webpack_public_path__ + "img/shoppingcart.5731eab4.svg";